// extracted by mini-css-extract-plugin
export var ContentWrapper = "F_bp";
export var Curtain = "F_b3";
export var EnterActive = "F_5";
export var EnterDone = "F_6";
export var ExitActive = "F_8";
export var ExitDone = "F_9";